module.exports = __webpack_public_path__ + "img/logo-WC.aea12751.png";